module.exports = __webpack_public_path__ + "static/img/business3.0805c59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business3.jpg
// module id = XMOv
// module chunks = 9